import React from 'react';
import { Route } from 'react-router-dom';
import NotFound from '.';

const route = <Route path="*" component={NotFound} />;

export default route;
